export { hallIdFromBooth, normalizeHallId, resolveMapHall } from "../floor/mapHall";

export function WalkIcon({ size = 14 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <path
        fill="currentColor"
        d="M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9 7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"
      />
    </svg>
  );
}

export function BoothNavButton({
  booth,
  onClick,
  variant = "link",
  shared = false,
}: {
  booth: string | null | undefined;
  onClick?: (booth: string) => void;
  variant?: "link" | "chip";
  shared?: boolean;
}) {
  if (!booth) return <span className="muted">—</span>;
  const mark = shared ? "*" : "";
  if (!onClick) {
    return variant === "chip" ? (
      <span className="chip company-chip booth-chip">Booth {booth}{mark}</span>
    ) : (
      <span>
        {booth}
        {mark}
      </span>
    );
  }
  const label = shared ? `Show shared booth ${booth} on floor` : `Show booth ${booth} on floor`;
  return (
    <button
      type="button"
      className={variant === "chip" ? "chip company-chip booth-chip booth-chip-btn" : "booth-link"}
      aria-label={label}
      title={label}
      onClick={(event) => {
        event.stopPropagation();
        onClick(booth);
      }}
    >
      {variant === "chip" ? `Booth ${booth}${mark}` : `${booth}${mark}`}
      <WalkIcon size={variant === "chip" ? 16 : 14} />
    </button>
  );
}
